module.exports = __webpack_public_path__ + "static/media/20ECE20.2a9fcaa0.jpg";